import {
  Empty,
  Spin,
  Tag
} from "antd";

import {
  GiftOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import AccountShell
  from "./accountShell";

import {
  getAccountVouchers
} from "../../api/account";

import {
  FormatVND
} from "../../utils/format";

export default function Vouchers() {
  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    getAccountVouchers()
      .then(res =>
        setData(
          res?.data?.data || []
        )
      )
      .finally(() =>
        setLoading(false)
      );
  }, []);

  return (
    <AccountShell
      title="Voucher"
      description="Các mã giảm giá hiện có"
    >
      <Spin spinning={loading}>
        {data.length ? (
          <div
            className="
              grid
              grid-cols-1
              md:grid-cols-2
              gap-3
            "
          >
            {data.map(item => (
              <div
                key={item.voucher_id}
                className="
                  relative
                  overflow-hidden
                  rounded-2xl
                  border
                  border-blue-100
                  bg-gradient-to-br
                  from-blue-50
                  to-white
                  p-5
                "
              >
                <GiftOutlined
                  className="
                    absolute
                    right-[-10px]
                    top-[-10px]
                    text-[80px]
                    text-blue-100
                  "
                />

                <div className="relative">
                  <Tag color="blue">
                    Voucher
                  </Tag>

                  <h3
                    className="
                      text-[16px]
                      font-bold
                      text-slate-900
                      mt-3
                      mb-1
                    "
                  >
                    {item.voucher_name}
                  </h3>

                  <p
                    className="
                      text-[13px]
                      text-slate-500
                      mb-2
                    "
                  >
                    Mã:{" "}
                    <strong
                      className="
                        text-blue-700
                      "
                    >
                      {item.voucher_code}
                    </strong>
                  </p>

                  <p
                    className="
                      text-[17px]
                      font-bold
                      text-red-600
                      m-0
                    "
                  >
                    Giảm{" "}
                    {FormatVND(
                      item.voucher_price
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Empty
            description="Hiện chưa có voucher"
          />
        )}
      </Spin>
    </AccountShell>
  );
}
